import { atomWithStorage, useAtom } from "@mdotm/shadcn/legacy/reactivity";
import type { Updater } from "@mdotm/shadcn/legacy/utils";

export const PortfolioListViewMode = {
	mixed: "MIXED",
	chart: "CHART",
	table: "TABLE",
} as const;

export type PortfolioListViewMode = (typeof PortfolioListViewMode)[keyof typeof PortfolioListViewMode];

export type PortfolioStudioStoreProps = {
	isightPanel?: {
		open: boolean;
	};
	viewMode: PortfolioListViewMode;
};

export const portfolioStudioDefault: PortfolioStudioStoreProps = {
	isightPanel: { open: true },
	viewMode: "MIXED",
};

export const portfolioStudioSettings$ = atomWithStorage<PortfolioStudioStoreProps>(
	"portfolioStudioAtom",
	portfolioStudioDefault,
);

export function usePortfolioStudioState(): {
	portfolioStudioStore: PortfolioStudioStoreProps;
	setPortfolioStudioStore: (newValue: PortfolioStudioStoreProps | Updater<PortfolioStudioStoreProps>) => void;
	reset(): void;
} {
	const [portfolioStudioStore, setPortfolioStudioStore] = useAtom(portfolioStudioSettings$);
	return {
		portfolioStudioStore,
		setPortfolioStudioStore,
		reset: () => setPortfolioStudioStore(portfolioStudioDefault),
	};
}
